import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Select as JLSelect } from 'jl-design-system/components/select/Select';

export class Select extends React.PureComponent {
  render() {
    const {
      id,
      options,
      required,
      value,
      onBlur,
      onChange,
      name,
      labelText,
      supportingText,
      errorText,
    } = this.props;

    return (
      <JLSelect
        id={id}
        value={value || 'default'}
        name={name || id}
        className={classnames({
          sessioncamexclude: true,
        })}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        labelText={labelText}
        supportingText={supportingText}
        errorText={errorText}
      >
        {options.map((option) => (
          <option
            key={option.value || option.displayName}
            value={option.value || option.displayName}
            hidden={option.hidden}
            disabled={option.disabled}
          >
            {option.displayName || 'None'}
          </option>
        ))}
      </JLSelect>
    );
  }
}

Select.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  required: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
  labelText: PropTypes.string,
  supportingText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  errorText: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  }).isRequired,
};

Select.defaultProps = {
  name: undefined,
  labelText: undefined,
  supportingText: undefined,
  errorText: undefined,
};
